import { getMonth } from "date-fns";
import * as React from "react";
import Snowfall from "react-snowfall";
import styles from "./santa.module.css";

const DECEMBER = 11; // 🥸

export const Santa = () => {
  const divRef = React.useRef<HTMLDivElement>(null);
  const [size, setSize] = React.useState({ width: 1, height: 1 });
  const enabled =
    getMonth(new Date()) === DECEMBER ||
    ["development", "preview"].includes(process.env.NEXT_PUBLIC_VERCEL_ENV!);

  React.useEffect(() => {
    const div = divRef.current;

    if (div === null) {
      return;
    }

    const observer = new ResizeObserver(([entry]) => {
      setSize({
        width: entry.contentRect.width,
        height: entry.contentRect.height,
      });
    });

    observer.observe(div);
    return () => observer.unobserve(div);
  }, []);

  if (!enabled) {
    return null;
  }

  const angle = Math.max(-40 / (size.width / size.height), -20);
  const duration = size.width / 200 - Math.log2(size.width / 300);

  return (
    <>
      <div
        ref={divRef}
        className={styles.santa}
        style={
          {
            "--angle": `${angle}deg`,
            "--duration": `${duration}s`,
          } as React.CSSProperties
        }
      />
      <Snowfall />
    </>
  );
};
